/* eslint-disable max-len */
import React from 'react';
import { mapObject, constant } from 'underscore';
import PropTypes from 'prop-types';

import { Progress, RadialProgress } from '@bingads-webui-react/progress';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getCircleProgressStyle } from '@bingads-webui-campaign/shared-image-experience-styles';

const BarUploadProgress = (props) => {
  const uploadProcessText = `${((100 * props.uploadedBytes) / props.totalBytes).toFixed(1)} %`;

  return (
    <div className="upload-progress-container">
      <Progress
        className="bar-upload-progress"
        progressPercentage={props.uploadedBytes / props.totalBytes}
      />
      <div className="bar-upload-progress-text">{uploadProcessText}</div>
    </div>);
};

const CircleUploadProgress = withDefaultStyles(props =>
  (
    <div className={props.classes.circle}>
      <RadialProgress
        progressPercentage={props.uploadedBytes / props.totalBytes}
        size={44}
        stroke="#0078d4"
        strokeWidth={4}
      />
    </div>
  ), getCircleProgressStyle);

export const UploadProgress = (props) => {
  switch (props.type) {
    case 'bar':
      return <BarUploadProgress {...props} />;
    case 'circle':
      return <CircleUploadProgress {...props} />;
    default:
      return null;
  }
};

UploadProgress.propTypes = {
  totalBytes: PropTypes.number.isRequired,
  uploadedBytes: PropTypes.number.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
    parseDecimal: PropTypes.func.isRequired,
  }).isRequired,
  type: PropTypes.string,
};

BarUploadProgress.propTypes = UploadProgress.propTypes;
CircleUploadProgress.propTypes = {
  ...UploadProgress.propTypes,
  classes: PropTypes.shape(mapObject(
    getCircleProgressStyle(),
    constant(PropTypes.string.isRequired)
  )).isRequired,
};

UploadProgress.defaultProps = {
  type: 'bar',
};
